import { t } from '@lingui/macro';
import { Box, Stack, Typography } from '@mui/material';
import type { FC } from 'react';

type Props = unknown;

export const ReadingKey: FC<Props> = (props: Props) => {
  return (
    <Stack direction="column" spacing={3} component="article">
      <Stack
        direction="column"
        spacing={1}
        alignItems="center"
        component="header"
      >
        <Typography variant="h4" color="primary.main">
          {t`Clés de lecture`}
        </Typography>
        <Typography variant="h3">{t`Compétences, expériences et formations | Les podiums`}</Typography>
      </Stack>
      <Typography>
        {t`Les compétences, expériences et formations qui se trouvent sur les podiums sont, par défaut, les 3 dernières que vous avez renseignées, dans chaque catégorie.`}
      </Typography>
      <Typography>
        {t`Vous pouvez affiner ces podiums en sélectionnant vos compétences, expériences et formations favorites en cliquant sur l'icône située dans chacune des cartes des listes ci-dessous.`}
      </Typography>
    </Stack>
  );
};
